export const GET_ALL_FLAT_BUDGETS = "GET_ALL_FLAT_BUDGETS"
export const CREATE_FLAT_BUDGET = "CREATE_FLAT_BUDGET"
export const UPDATE_FLAT_BUDGET = "UPDATE_FLAT_BUDGET"
export const DELETE_FLAT_BUDGET = "DELETE_FLAT_BUDGET"
export const SELECT_FLAT_BUDGET = "SELECT_FLAT_BUDGET"
